import type { FeatureFlag } from '@risksmart-app/modules/src/index';

/**
 * Per-entity Smart Copy descriptor for Custom Data Sources — the single source
 * of truth for the register's gate + tooltip wording. Mirrors
 * `controlTestSmartCopy.ts` / `indicatorSmartCopy.ts`.
 *
 * - `flagKey` — per-org feature flag read via `useIsFeatureFlagEnabled`,
 *   resolved from OpenFeature (flagd locally/ephemeral, Datadog on
 *   dev-cloud/prod) or the seeded Meta.features override for e2e test orgs;
 *   registered in `packages/feature-flags/src/flags.ts`.
 * - `eventLabel` — prefixes the Amplitude event names (capitalised); consumed
 *   when analytics land in a follow-up.
 * - `entityNoun` — interpolates into the disabled "copy" tooltip (lowercase).
 */
export const CUSTOM_DATASOURCE_SMART_COPY = {
  flagKey: 'smart_copy_custom_datasource' satisfies FeatureFlag,
  eventLabel: 'Custom Data Source',
  entityNoun: 'custom data source',
} as const;
